import { render, staticRenderFns } from "./linkSetting.vue?vue&type=template&id=1034918c&scoped=true"
import script from "./linkSetting.vue?vue&type=script&lang=js"
export * from "./linkSetting.vue?vue&type=script&lang=js"
import style0 from "./linkSetting.vue?vue&type=style&index=0&id=1034918c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1034918c",
  null
  
)

export default component.exports